module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row row-slim">\n    <div class="page-col-offset input-help">\n        <span class="create-step-number">&nbsp;</span>\n    </div>\n    <div class="page-col-6">\n        <label class="label-headline">'+
((__t=(item.field.label))==null?'':_.escape(__t))+
'</label>\n    </div>\n</div>\n\n<div id="subregion-additional-species"></div>';
}
return __p;
};